module.exports = __webpack_public_path__ + "static/media/Ledmac_Wechat_Qr_Code_Banner.a1e30a53.jpeg";